import { Box } from '@mui/material';
import React from 'react';

interface SimpleProgressBarProps{
    loading: boolean;
    size: number;
}

const SimpleProgressBar : React.FC<SimpleProgressBarProps> = ({loading, size}) => {
  if (!loading) return null;
  return (
          <Box
            component="img"
            src="/loading-logo.gif"
            alt="logo-icon"
            sx={{ width: `${size}px` }}
          />
  )}
export default SimpleProgressBar;